import spacetime from 'spacetime'

export default function isDayMode() {
  const now = spacetime.now('America/New_York')
  const nightStart = now.time('2:00pm')
  const nightEnd = now.time('11:00pm')
  const isNightMode = now.isAfter(nightStart) && now.isBefore(nightEnd)
  return !isNightMode
}
